<template>
    <div>
        <div class="rounded-lg border border-gray-200 bg-gray-50 p-4">
            <div>
                <h4 class="text-sm font-semibold text-gray-900 mb-1">Social media templates</h4>
                <p class="text-sm text-gray-700">
                    Partners will see ready-to-use templates for Instagram and TikTok that automatically include their promo codes and referral links.
                </p>
                <div class="mt-3 space-y-2">
                    <div class="flex items-center gap-2 text-sm text-gray-600">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/>
                        </svg>
                        <span>Story/Video cover templates (1080×1920)</span>
                    </div>
                    <div class="flex items-center gap-2 text-sm text-gray-600">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/>
                        </svg>
                        <span>Square post templates (1080×1080)</span>
                    </div>
                    <div class="flex items-center gap-2 text-sm text-gray-600">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/>
                        </svg>
                        <span>Caption generator with platform-specific hashtags</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['unique_id', 'data', 'options'],
    created() {
        // Initialize templates array if not present
        if (!this.data.templates) {
            this.data.templates = [
                {
                    type: 'story',
                    unique_id: 'social_story_default',
                    title: 'Story / Video Cover',
                    description: 'For Instagram Stories and TikTok videos',
                    dimensions: '1080×1920',
                    icon: 'story',
                },
                {
                    type: 'post',
                    unique_id: 'social_post_default',
                    title: 'Square Post',
                    description: 'For Instagram and TikTok feed posts',
                    dimensions: '1080×1080',
                    icon: 'post',
                },
                {
                    type: 'caption',
                    unique_id: 'social_caption_default',
                    title: 'Caption Generator',
                    description: 'Auto-generated captions for Instagram and TikTok',
                    dimensions: 'Text',
                    icon: 'caption',
                },
            ];
        }
    }
}
</script>
